var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-tree sys-center-zuzhijigou"},[_c('lr-tree',{ref:_vm.treeBindRef,attrs:{"data":_vm.treeData,"width":_vm.width,"loading":_vm.treeLoading,"bindRef":_vm.treeBindRef,"nodeKey":"ID","title":_vm.treeTitle,"defaultProps":_vm.defaultProps},on:{"setTreeWidth":_vm.setTreeWidth,"nodeClick":_vm.nodeClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34485d56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LrOrganization/SelfDeptTree.vue
// module id = null
// module chunks = 